export default function FormDividerText(props){
    return (<>
        <p
        className="relative text-center before before:w-1/2 before:h-[1px] before:bg-gray-200 before:absolute before:left-0 before:top-1/2 af after:w-1/2 after:h-[1px] after:bg-gray-200 after:absolute after:right-0 after:top-1/2">
        <span className="bg-white px-2 relative z-10 text-sm font-Outfit font-medium text-textColor">{props.children}</span>
        </p>
    </>);
}